import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import { Link } from 'react-router';
import { useState } from 'react';
import { UiCommon } from '@/common/common';
import { NAV_PATH } from '@/router/constants';

const popupImages = {
	banner1: require('@/assets/images/common/img_popup1.jpg'),
	banner2: require('@/assets/images/common/img_popup2.jpg'),
	banner3: require('@/assets/images/common/img_popup3.jpg')
};
const popupBanner = [
	{
		src: popupImages.banner3,
		link: NAV_PATH.FUNCTION.MAIN + '#yeartaxset',
		target: '_self'
	},
	{
		src: popupImages.banner2,
		link: NAV_PATH.FUNCTION.CONVENIENCE + '#pharosAI',
		target: '_self'
	},
	{
		src: popupImages.banner1,
		link: UiCommon.getStellaUrl(),
		target: '_blank'
	}
];

const PopupBanner = () => {
	const [bannerClosed, setBannerClosed] = useState(false); // 닫기 여부

	return (
		<div className={`popup-banner ${!bannerClosed ? 'active' : ''}`}>
			<Swiper
				modules={[Pagination, Autoplay]}
				spaceBetween={0}
				slidesPerView={1}
				loop
				autoplay={{
					delay: 5000,
					speed: 5000
				}}
				observer={true}
				observeParents={true}>
				{popupBanner.map((slide, index) => (
					<SwiperSlide key={index}>
						<Link to={slide.link} target={slide.target}>
							<img src={slide.src} />
						</Link>
					</SwiperSlide>
				))}
				<div className="swiper-pagination"></div>
			</Swiper>

			<div className="popup-banner-btns">
				<button type="button" className="popup-banner-btn btn1 hidden">
					일주일간 보지 않기
				</button>
				<button type="button" className="popup-banner-btn btn2" onClick={() => setBannerClosed(true)}>
					닫기
				</button>
			</div>
		</div>
	);
};

export default PopupBanner;
